/**
 * Created by TF on 2018/6/20
 */
import axios from 'axios';
let qs = require('qs');

let base = 'http://47.104.248.56:8081';

var instance = axios.create({
    headers: {
        // 'content-type': 'application/json',
        'Authorization': ''
    }
});
instance.interceptors.request.use(
    config => {
        config.headers.Authorization = sessionStorage.getItem('Authorization');
        return config
    }, err => {
        return Promise.reject(err)
    });

export const reqGetLogin = params => { return instance.post(`${base}/webUser/login`, qs.stringify(params)).then(res => res.data) }
// 微信登录
export const reqGetWxLogin = params => { return instance.post(`${base}/webUser/wxLogin`, qs.stringify(params)).then(res => res.data) }
// 微信端在个人中心用户修改密码后重新登录系统(和授权无关，只是单纯的登录)
export const reqWxLoginByChangePwd = params => { return instance.post(`${base}/webUser/wxLoginByChangePwd`, qs.stringify(params)).then(res => res.data) }

export const reqGetRegister = params => { return instance.post(`${base}/webUser/register`, params) }
// 网站用户注册时发送短信验证码：
export const  reqPhoneCaptcha= params => { return instance.get(`${base}/webUser/getPhoneCaptcha`, { params: params }) }

// 微信用户注册时发送短信验证码
export const  reqWxPhoneCaptcha= params => { return instance.get(`${base}/webUser/getWxPhoneCaptcha`, { params: params }) }
// 微信用户注册
export const reqGetWxRegister = params => { return instance.post(`${base}/webUser/wxRegister`, params) }
// 微信用户找回密码时，获取手机验证码
export const  reqWxForgetPwdCaptcha= params => { return instance.get(`${base}/webUser/getWxForgetPwdCaptcha`, { params: params }) }
// 微信用户找回密码时，验证手机验证码是否正确
export const reqGoWxChangePwd = params => { return instance.post(`${base}/webUser/goWxChangePwd`, params) }
// 判断用户名是否重复
export const  reqRepeatUsername= params => { return instance.get(`${base}/webUser/RepeatUsername`, { params: params }) }

// 找回密码时，获取验证码：
export const  reqForgetPwdCaptcha= params => { return instance.get(`${base}/webUser/getForgetPwdCaptcha`, { params: params }) }

// 验证验证码是否有效
export const reqGoChangePwd = params => { return instance.post(`${base}/webUser/goChangePwd`, params) }

// 修改密码，通过手机号
export const reqChangePwd = params => { return instance.post(`${base}/webUser/resetPwd`, params) };
// export const reqGetChangePwd = params => { return instance.post(`${base}/webUser/editByPhoneNumber`, params) };


// 通过id查询
export const  reqWebUserOne= params => { return instance.get(`${base}/webUser/selectByTokeId`, { params: params }) };
//修改个人信息
export const  reqWebUserEdit= params => { return instance.post(`${base}/webUser/webUserEdit`, qs.stringify(params)) };

//修改密码
export const  reqPasswordEdit= params => { return instance.get(`${base}/webUser/passwordEdit`, { params: params })  };
//我的成交记录
export const  reqMyLan= params => { return instance.get(`${base}/webUser/myLan`, { params: params })  };
export const  reqMyBorrow= params => { return instance.get(`${base}/webUser/myBorrow`, { params: params })  };
export const  reqAssignmentDebt= params => { return instance.get(`${base}/webUser/myAssignmentDebt`, { params: params })  };
//我的意向
export const  reqMyBorrowIntention= params => { return instance.get(`${base}/webUser/myBorrowIntention`, { params: params })  };
export const  reqMyLanIntention= params => { return instance.get(`${base}/webUser/myLanIntention`, { params: params })  };
export const  reqMyBorrowById= params => { return instance.get(`${base}/webUser/myBorrowById`, { params: params })  };
export const  reqMyLoanById= params => { return instance.get(`${base}/webUser/myLoanById`, { params: params })  };
export const  reqMyAssignmentDebtIntention= params => { return instance.get(`${base}/webUser/myAssignmentDebtIntention`, { params: params })  };
//我的借入意向分页
export const  reqMyBorrowIntentionPage= params => { return instance.get(`${base}/webUser/myBorrowIntentionPage`, { params: params })  };
//我的出借意向分页
export const  reqMyLanIntentionPage= params => { return instance.get(`${base}/webUser/myLanIntentionPage`, { params: params })  };
//我的借入分页
export const  reqMyBorrowPage= params => { return instance.get(`${base}/webUser/myBorrowPage`, { params: params })  };
//我的出借分页
export const  reqMyLanPage= params => { return instance.get(`${base}/webUser/myLanPage`, { params: params })  };
//我的债转意向分页
export const  reqMyAssignmentDebtIntentionPage= params => { return instance.get(`${base}/webUser/myAssignmentDebtIntentionPage`, { params: params })};
//我的债权转让分页
export const  reqMyAssignmentDebtPage= params => { return instance.get(`${base}/webUser/myAssignmentDebtPage`, { params: params })};
export const  reqMyAsDeTotalContractAmount= params => { return instance.get(`${base}/webUser/myAsDeTotalContractAmount`, { params: params })};
//我的借入总金额
export const  reqMyBorrowTotalLanContractAmount= params => { return instance.get(`${base}/webUser/totalBorrowContractAmount`, { params: params })  };
//我的出借总金额
export const  reqMyLanTotalLanContractAmount= params => { return instance.get(`${base}/webUser/totalLanContractAmount`, { params: params })  };
// 微信端获取图片验证码：
export const reqCodeImg = params => { return instance.get(`${base}/webUser/getCodeImg`, {params: params}) }
// 获取图片验证码是否正确。
export const reqCodeImageIsTrue = params => { return instance.get(`${base}/webUser/getCodeImgIsTrue`, {params: params}) }

// 普惠借贷 header显示用户名：
export const reqUserNameByToken = params => { return instance.post(`${base}/adminUser/userNameByToken`, params) };


// 微信个人资料中,修改个人信息
export const  reqWebUserOneById= params => { return instance.get(`${base}/webUser/one`, { params: params }) };
// 微信统计我的出借总数量
export const  reqWxMyLoanCount= params => { return instance.get(`${base}/webUser/wxLoanContractAmountAndTotals`, { params: params })  };
export const  reqWxMyBorrowCount= params => { return instance.get(`${base}/webUser/wxBorrowContractAmountAndTotals`, { params: params })  };
export const  reqWxMyAssignmentDebtCount= params => { return instance.get(`${base}/webUser/wxAssignmentDebtContractAmountAndTotals`, { params: params })  };
export const  reqWxMyCustomCount= params => { return instance.get(`${base}/userCustomer/wxMyCustomCount`, { params: params })  };
// 微信端我的出借详情
export const  reqWxMyLoanPage= params => { return instance.get(`${base}/webUser/wxLoanPage`, { params: params })  };
export const  reqWxMyBorrowPage= params => { return instance.get(`${base}/webUser/wxBorrowPage`, { params: params })  };
export const  reqWxMyAssignmentDebtPage= params => { return instance.get(`${base}/webUser/wxAssignmentDebtPage`, { params: params })  };
export const  reqMyCustomerInfo= params => { return instance.get(`${base}/userCustomer/wxCustomerInfo`, { params: params })  };

// 关联业务员分享二维码注册的用户
export const reqAddReferrer = params => { return instance.post(`${base}/userCustomer/add`, qs.stringify(params))};



// WEBPACK FOOTER //
// ./src/api/webUser-api.js